import JSDB from '../../../fromKotlin/nk';

const ORDER_EXTRA_NOTE_NUMBERS = [2, 3, 4, 5, 6, 7, 8, 9, 10] as const;

export const ORDER_NOTE_FIELD_IDS = ['notes', ...ORDER_EXTRA_NOTE_NUMBERS.map((n) => `notes${n}`)] as const;

export type OrderNoteField = {
    id: string;
    label: string;
    hasCustomLabel: boolean;
};

/** Same labels as datasheet columns — from user JSON desc (`notes2` … `notes10`). */
export function getOrderExtraNoteFields(): OrderNoteField[] {
    return ORDER_EXTRA_NOTE_NUMBERS.map((n) => {
        const id = `notes${n}`;
        const desc = JSDB().getUser().first?.getJsonDesc(id);
        const customName = desc?.name?.trim?.() ? String(desc.name).trim() : '';
        return {
            id,
            label: customName || `הערות ${n}`,
            hasCustomLabel: Boolean(customName),
        };
    });
}

export function getOrderNoteFieldLabel(fieldId: string, fallback?: string): string {
    const desc = JSDB().getUser().first?.getJsonDesc(fieldId);
    const customName = desc?.name?.trim?.() ? String(desc.name).trim() : '';
    if (customName) return customName;
    if (fallback) return fallback;
    const match = /^notes(\d+)$/.exec(fieldId);
    return match ? `הערות ${match[1]}` : fieldId;
}
